import { render, staticRenderFns } from "./Editor-135.vue?vue&type=template&id=fb07d178&"
import script from "./Editor-135.vue?vue&type=script&lang=js&"
export * from "./Editor-135.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports